import React from "react";
import { useNavigate } from 'react-router-dom';
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import CustomTable from "../../Common/CustomTable";

import "./AnalyticsTable.css";

const makeStyle = (status) => {
    if (status === 'Correct') {
        return {
            background: 'rgb(145 254 159 / 47%)',
            color: 'green',
        }
    }
    else if (status === 'Incorrect') {
        return {
            background: '#ffadad8f',
            color: 'red',
        }
    } else if (status === 'Watched') {
        return {
            background: 'rgb(145 254 159 / 47%)',
            color: 'green',
        }
    } else if (status === 'Not watched') {
        return {
            background: '#ffadad8f',
            color: 'red',
        }
    } else if (status === 'Completed') {
        return {
            background: 'rgb(145 254 159 / 47%)',
            color: 'green',
        }
    } else if (status === 'Ready') {
        return {
            background: '#ffadad8f',
            color: 'red',
        }
    }
    else {
        return {
            background: '#59bfff',
            color: 'white',
        }
    }
}

const AnalyticsTable = ({ data, view = 'questions' }) => {
    const navigate = useNavigate();

    const getTitle = (key) => {
        const titles = [
            { key: 'questions', value: 'Recently Attempted Questions' },
            { key: 'lectures', value: 'Recently Delivered Lectures' },
            { key: 'tests', value: 'Recent Taken Tests' },
        ];

        const item = titles.find(title => title.key === key);
        return item ? item.value : null;
    };

    console.log(data);

    const getTableHeaders = () => {
        switch (view) {
            case 'questions':
                return [
                    { label: 'Question ID', align: 'left' },
                    { label: 'Difficulty', align: 'center' },
                    { label: 'Topic', align: 'center' },
                    { label: 'Source', align: 'center' },
                    { label: 'Date', align: 'center' },
                    { label: 'Status', align: 'center' },
                ];
            case 'lectures':
                return [
                    // { label: 'Lecture ID', align: 'left' },
                    { label: 'Subject', align: 'left' },
                    { label: 'Teacher', align: 'center' },
                    { label: 'Delivery Date', align: 'center' },
                    { label: 'Topic', align: 'center' },
                    { label: 'Status', align: 'center' },
                    { label: 'Latest Revised Date', align: 'center' },
                    { label: 'Revision Times', align: 'center' },
                ];
            case 'tests':
                return [
                    // { label: 'Lecture ID', align: 'left' },
                    { label: 'Name', align: 'center' },
                    { label: 'Date', align: 'center' },
                    { label: 'Time', align: 'center' },
                    { label: 'Type', align: 'center' },
                    { label: 'Duration', align: 'center' },
                    { label: 'Status', align: 'center' },
                    { label: 'Score', align: 'center' },
                    { label: 'Retake Time', align: 'center' },
                ];
            default:
                return [];
        }
    };

    const renderRow = (row, index) => (
        <TableRow
            key={index}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
        >
            {view === 'questions' &&
                <>
                    <TableCell component="th" scope="row">
                        <span className={`questionID ${row.questionID[0]}`}>{row.questionID}</span>
                    </TableCell>
                    <TableCell align="center">
                        <span className={`difficulty ${row.difficulty}`}>{row.difficulty}</span>
                    </TableCell>
                    <TableCell align="left">
                        <span className="topic">{row.topic}</span>
                    </TableCell>
                    <TableCell align="center">{row.source}</TableCell>
                    <TableCell align="center">{row.date}</TableCell>
                    <TableCell align="center">
                        <span className={`status ${row.status}`} style={makeStyle(row.status)}>{row.status}</span>
                    </TableCell>
                </>
            }
            {view === 'lectures' &&
                <>
                    {/* <TableCell component="th" scope="row">
                        <span className={`lectureID ${row.subject[0]}`}>{row.subject[0]}{row.lectureID}</span>
                    </TableCell> */}
                    <TableCell component="th" scope="row" align="left">
                        <span className={`subject ${row.subject[0]}`}>{row.subject}</span>
                    </TableCell>
                    <TableCell align="center">
                        <span className={`teacher ${row.teacher}`}>{row.teacher}</span>
                    </TableCell>
                    <TableCell align="center">{row.lectureDate}</TableCell>
                    <TableCell align="left">
                        <span className="topic">{row.topic}</span>
                    </TableCell>
                    <TableCell align="center">
                        <span className={`status ${row.status}`} style={makeStyle(row.status)}>{row.status}</span>
                    </TableCell>
                    <TableCell align="center">{row.dateWatched}</TableCell>
                    <TableCell align="center">{row.watchedTimes}</TableCell>
                </>
            }
            {view === 'tests' &&
                <>
                    <TableCell align="left">
                        <span className="name">{row.testName}</span>
                    </TableCell>
                    <TableCell align="center">{row.testDate}</TableCell>
                    <TableCell align="center">{row.testTime}</TableCell>
                    <TableCell align="center">
                        <span className="type">{row.testType}</span>
                    </TableCell>
                    <TableCell align="center">{row.duration}</TableCell>
                    <TableCell align="center">
                        <span className={`status ${row.status}`} style={makeStyle(row.status)}>{row.status}</span>
                    </TableCell>
                    <TableCell align="center">{row.score}</TableCell>
                    <TableCell align="center">{row.retakeTime}</TableCell>
                </>
            }
        </TableRow>
    );

    return (
        <CustomTable
            title={getTitle(view)}
            headers={getTableHeaders()}
            data={data}
            renderRow={renderRow}
        />
    );
};

export default AnalyticsTable;